module.exports = __webpack_public_path__ + "static/img/use.2000e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/use.png
// module id = Wv2I
// module chunks = 1